import styled from 'styled-components';

const BlackLine = styled.div`
  border: ${({ size }) => (size ? `${size}px` : '1px')} solid black;
`;

export default BlackLine;
